export const pageSx = (theme) => ({
    display: "grid",
    gridTemplateColumns: {
        xs: "1fr",
        md: "1fr minmax(0, 600px) 1fr",
    },
    gap: 3,
    mx: "auto",
    px: {xs: 0, sm: 2, md: 4},
})

export const baseBoxSx = (theme) => ({
    my: 2,
    p: {xs: 1, sm: 2, lg: 4},
    borderRadius: {sm: 2},
    boxShadow: {xs: 1, sm: 3},
    textAlign: 'center',
    bgcolor: '#fafafa',
    position: 'relative',
});

export const contentSx = (theme) => ({
    mt: {sm: 2},
    minWidth: 340,
})

export const adRailSx = (theme) => ({
    position: "sticky",
    top: 0,
    pt: 4,
    display: { xs: "none", md: "flex" },
    justifyContent: 'center',
    alignSelf: "start",
})

export const adInlineSx = (theme) => ({
    // display: { xs: "block", md: "none"},
    textAlign: 'center',
    minWidth: 340,
})
